import {
  Box,
  BoxProps,
  ColorOptions,
  convertHexToRGBA,
  ModalDialogNew,
  Spacer,
  Text,
  TextInput,
  TextProps,
} from '@jfs/ui-new'
import { FC, useEffect, useRef, useState } from 'react'
import { Dimensions, FlatList, InteractionManager, TextInput as RNTextInput } from 'react-native'
import { SvgImage } from '../../../../comps/SvgImage'
import {
  Colors,
  ContactsModule,
  extractFirstLetterFromName,
  hasReadContactsPermission,
  isOsMobile,
} from '../../../../util/util'
import { TextInputWithLabelOnBorder } from './TextInputWithLabelOnBorder'

const height = Dimensions.get('screen').height

const ContactsModalInput: FC = ({ rightComponent, error, touched, disabled, ...props }: any) => {
  const [showContacts, setShowContacts] = useState(false)
  const [contactsTouched, setTouched] = useState(touched)
  //const [mobile, setMobile] = useState(props.value)
  const [contatctsData, setData] = useState<any>([])
  const [searchData, setSearchData] = useState<any>(contatctsData)
  const searchInput = useRef<RNTextInput>(null)

  useEffect(() => {
    if (showContacts) {
      InteractionManager.runAfterInteractions(() => {
        if (searchInput.current) {
          searchInput.current.focus()
        }
      })
    }
  }, [showContacts])

  const openContacts = () => {
    hasReadContactsPermission().then((granted) => {
      if (granted) {
        ContactsModule.getContacts((contacts: any) => {
          const names = Object.keys(contacts)
          const numbers = Object.values(contacts)
          const data: any = []
          numbers.map((number: any, index: number) => {
            const num = number.replace('+91', '')
            const retItem: any = {
              id: `${index}`,
              title: names[index],
              subTitle: num,
            }
            num?.length === 10 && data.push(retItem)
          })
          data.sort((a: any, b: any) => {
            if (a.title.toLowerCase() < b.title.toLowerCase()) {
              return -1
            }
            if (a.title.toLowerCase() > b.title.toLowerCase()) {
              return 1
            }
            return 0
          })

          if (names.length > 0 && numbers.length > 0)
          {
                setShowContacts(true)
                setData(data)
                setSearchData(data)
          }
        
        })
      } else {
        console.log('Permission denied')
      }
    })
  }

  const keyExtractor = (item: any): string => {
    return item?.id
  }

  const handleOnPress = (item: any) => {
    setShowContacts(false)
    //setMobile(item.subTitle)
    if (props.setFieldValue && props.fieldName) {
      props.setFieldValue(props.fieldName, item.subTitle)
      props.setFieldValue('userName', item.title)
    }
  }
  const renderListItem = ({ item }: any) => {
    return (
      <Box
        flexDirection={'row'}
        ph={5}
        pv={8}
        justify={'center'}
        testID="contact-"
        onPress={() => handleOnPress(item)}
        marginVertical={10}
        underlayColor={'TRANSPARENT'}>
        <Box {...styles.iconContainer}>
          <Text {...styles.nameOutline}>{extractFirstLetterFromName(item.title)}</Text>
        </Box>
        <Box pl={20} flex={1} justify="center">
          <Text {...styles.title}>{item.title}</Text>
          <Spacer size={2} />
          <Text {...styles.subTitle}>{item.subTitle}</Text>
        </Box>
      </Box>
    )
  }

  const handleOnChange = (text: string) => {
    const searchfn = (item: any) => {
      const search = text.toLowerCase()
      const titleText = item?.title?.toLowerCase() ?? ''
      const subTitleText = item?.subTitle?.toLowerCase() ?? ''
      return titleText.includes(search) || subTitleText.includes(search)
    }

    const data = contatctsData?.filter(searchfn)
    setSearchData(data)
  }

  const rightComp = () => {
    if (!isOsMobile()) {
      return null
    }
    return (
      <Box underlayColor={'TRANSPARENT'} testID="open-contact" onPress={openContacts}>
        {rightComponent}
      </Box>
    )
  }

  return (
    <Box width={'100%'}>
      <TextInputWithLabelOnBorder
        touched={contactsTouched}
        editable={!disabled}
        rightComponent={disabled ? null : rightComp()}
        error={error}
        inputMode={'numeric'}
        onPressIn={() => setTouched(true)}
        width={'100%'}
        height={48}
        textWrapperStyles={{ paddingRight: 6 }}
        selectionColor={Colors.PRIMARY}
        {...props}
      />
      <ModalDialogNew
        type={'bottom'}
        animate={true}
        show={showContacts}
        onDismiss={() => setShowContacts(false)}
        backgroundColor={'TRANSPARENT'}>
        <Box bg={'WHITE'} borderTopLeftRadius={35} borderTopRightRadius={35} p={25} pt={35} minHeight={height / 2}>
          <Box flexDirection={'row'} align={'center'} justify={'space-between'}>
            <Text {...styles.headerText}>Contacts</Text>
            <Box underlayColor={'TRANSPARENT'} testID="close-contact" onPress={() => setShowContacts(false)}>
              <SvgImage imageName="Close" />
            </Box>
          </Box>
          <Spacer direction={'vertical'} size={30} />
          <Box
            flexDirection={'row'}
            align={'center'}
            marginBottom={6}
            borderWidth={1}
            borderColor={searchInput?.current?.isFocused() ? ('#000' as ColorOptions) : ('#B5B5B5' as ColorOptions)}
            borderRadius={8}
            width={'100%'}
            ph={10}>
            <SvgImage imageName="SearchIcon" />
            <Spacer direction={'horizontal'} size={16} />
            <TextInput
              bottomLineColor={'TRANSPARENT'}
              placeholder={'Enter name or mobile number'}
              onFocusBottomLineColor={'TRANSPARENT'}
              placeholderTextColor={Colors.PRIMARY_GREY}
              onChangeText={handleOnChange}
              fontFamily={'JioType-Medium'}
              fontSize={14}
              color={Colors.BLACK_14 as ColorOptions}
              innerRef={searchInput}
              autoFocus={true}
              selectionColor={Colors.PRIMARY}
            />
          </Box>
          <FlatList data={searchData} renderItem={renderListItem} keyExtractor={keyExtractor} extraData={searchData} />
        </Box>
      </ModalDialogNew>
    </Box>
  )
}

const styles = {
  iconContainer: {
    height: 40,
    width: 40,
    borderRadius: 20,
    bg: convertHexToRGBA(Colors.PRIMARY, 8) as ColorOptions,
    alignItems: 'center',
    justify: 'center',
  } as BoxProps,
  headerText: {
    fontSize: 24,
    fontFamily: 'JioType-Black',
    color: Colors.BLACK_14,
  } as TextProps,
  nameOutline: {
    color: Colors.SECONDARY,
    fontSize: 12,
    fontFamily: 'JioType-Bold',
    letterSpacing: -0.06,
  } as TextProps,
  title: {
    color: Colors.BLACK_14,
    fontSize: 14,
    fontFamily: 'JioType-Bold',
  } as TextProps,
  subTitle: {
    color: Colors.PRIMARY_GREY,
    fontSize: 12,
    fontFamily: 'JioType-Medium',
  } as TextProps,
}

export { ContactsModalInput }
